import { render, staticRenderFns } from "./EmployeesAccount.vue?vue&type=template&id=dddcec12&scoped=true&"
import script from "./EmployeesAccount.vue?vue&type=script&lang=js&"
export * from "./EmployeesAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddcec12",
  null
  
)

export default component.exports